<template>
	<div>
		<div
			v-for="item in items"
			:key="`previewFuel-${item.id}`"
			class="d-flex my-3"
		>
			<ao-groupbox custom="preview">
				<div class="d-flex">
					<img v-if="item.photo"
						width="32"
						height="32"
						class="mr-4"
						:src="item.photo"
						alt=""
					>
					<div class="d-flex flex-column">
						<span class="ao-p1 text-textBody">{{ item.name }}</span>
						<span class="ao-p1 ao-p4-regular ">{{ item.role }}</span>
					</div>
					<v-spacer/>
					<ao-icon-btn variant='plain'
						size='18'
						iconName="pen"
						class="mr-1"
						@click="$emit('edit', item.id)"/>
					<ao-icon-btn variant='plain'
						size='18'
						iconName="delete"
						@click="$emit('delete', item.id)"/>
				</div>
			</ao-groupbox>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormsMicroformEmployees',
	props: {
		items: {
			type: Array,
		},
	},
	emits: ['edit', 'delete'],
}
</script>

<style lang="scss"></style>
